import { Routes } from '@angular/router';
import { AuthGuard } from '@utils/guards/auth.guard';

export const userRoutes: Routes = [
  {
    path: 'usuarios',
    loadComponent: () =>
      import('./users.component').then((c) => c.UsersComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'crear-editar-usuario',
    loadComponent: () =>
      import('./pages/create-update-user/create-update-user.component').then(
        (c) => c.CreateUpdateUserComponent
      ),
    canActivate: [AuthGuard],
  },
];
